import globals from 'src/app/utils/globals';
import { TrackingEvent } from 'src/types/trackingData';
import { TealiumViewEvent } from 'src/app/utils/analytics/utils/getViewEventDataByPage/type';
import { isProd } from 'src/app/utils/environment';

export const isCypress = () => !isProd() && Boolean(globals.window.Cypress);

type CypressTrackerEventName =
  | TrackingEvent['eventName']
  | TealiumViewEvent['eventName'];
type CypressTrackerEventData = TrackingEvent['data'] | TealiumViewEvent['data'];

export const createCypressTracker = (): {
  sendUtagViewEventToCypressTracker: (
    eventName: CypressTrackerEventName,
    data: CypressTrackerEventData,
  ) => void;
  initCypressTracker: () => void;
} => {
  const initCypressTracker = () => {
    if (isCypress()) {
      globals.window.cypressTracker = ({ eventName, data }) => {};
    }
  };

  const sendUtagViewEventToCypressTracker = (
    eventName: CypressTrackerEventName,
    data: CypressTrackerEventData,
  ) => {
    if (!isProd() && typeof globals.window.cypressTracker === 'function') {
      globals.window.cypressTracker({ eventName, data });
    }
  };

  return {
    initCypressTracker,
    sendUtagViewEventToCypressTracker,
  };
};
